module.exports = __webpack_public_path__ + "img/logout-icon.8df54b01.svg";